module.exports = __webpack_public_path__ + "img/1.7494160b.webp";